// FilterTags1.js
import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

const FilterTags = ({ selectedFilters, removeFilter }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 1,
        padding: '8px 16px',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
        marginBottom: '16px',
      }}
    >
      {Object.entries(selectedFilters).map(([facetName, values]) =>
        values.map((value) => (
          <Chip
            key={`${facetName}-${value}`}
            label={`${facetName}: ${value}`}
            onDelete={() => removeFilter(facetName, value)}
            color="primary"
            variant="outlined"
            sx={{ fontSize: '0.875rem' }}
          />
        ))
      )}
      {Object.keys(selectedFilters).length === 0 && (
        <Typography variant="body2" sx={{ color: '#666' }}>
          No filters applied
        </Typography>
      )}
    </Box>
  );
};

export default FilterTags;
